import { useEffect } from 'react';
import { extractValues, updateUrlParams } from '../../validation/ValidationInput';

const LEGACY_PATH = /\/orderApproval\/?$/i;

/**
 * Legacy /orderApproval list: now the Approval tab of Order management.
 * The route stays (host menus link here); it only redirects, keeping search/page/limit.
 */
const OrderApproval = () => {
  useEffect(() => {
    // Already redirected (e.g. a StrictMode re-run of this effect).
    if (!LEGACY_PATH.test(location.pathname)) return;
    const params: any = extractValues(location.search.split('&'));
    const target =
      location.pathname.replace(LEGACY_PATH, '/orderManagement') +
      updateUrlParams({ searchValue: params.search, tab: 'approval', page: params.page, limit: params.limit });
    // Replace this entry and let the host router re-read it: Back skips the redirect.
    window.history.replaceState(window.history.state, '', target);
    window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
  }, []);

  return null;
};

export default OrderApproval;
